"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageWrapper = exports.ControlButton = exports.CarouselWrapper = exports.BottomCarouselWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const background = 'rgba(0, 0, 0, 0.5)';
const CarouselWrapper = exports.CarouselWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1ukuf8x3"
} : {
  target: "e1ukuf8x3",
  label: "CarouselWrapper"
})(({
  height,
  theme,
  radius,
  withShadow
}) => /*#__PURE__*/(0, _react.css)(withShadow && /*#__PURE__*/(0, _react.css)("box-shadow:", theme.shadowSmall, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:CarouselWrapper;")), " width:100%;height:100%;max-height:", height, ";display:flex;align-items:baseline;border-radius:", radius ? radius : '4px', ";overflow:hidden;.slider-container{max-width:100%;}" + (process.env.NODE_ENV === "production" ? "" : ";label:CarouselWrapper;")));
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1pt2o8x",
  styles: "margin-right:3px"
} : {
  name: "9g5zwe-ControlButton",
  styles: "margin-right:3px;label:ControlButton;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1i7v2bx",
  styles: "margin-left:3px"
} : {
  name: "1arqgkz-ControlButton",
  styles: "margin-left:3px;label:ControlButton;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const ControlButton = exports.ControlButton = /*#__PURE__*/(0, _base.default)("button", process.env.NODE_ENV === "production" ? {
  target: "e1ukuf8x2"
} : {
  target: "e1ukuf8x2",
  label: "ControlButton"
})(({
  direction
}) => /*#__PURE__*/(0, _react.css)("background-color:", background, ";border:none;border-radius:50%;padding:0.75em;cursor:pointer;", direction === 'left' ? _ref2 : _ref, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ControlButton;")));
const BottomCarouselWrapper = exports.BottomCarouselWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1ukuf8x1"
} : {
  target: "e1ukuf8x1",
  label: "BottomCarouselWrapper"
})("display:flex;justify-content:center;padding:0.25em 1em;border-radius:5px;background-color:", background, ";");
const ImageWrapper = exports.ImageWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1ukuf8x0"
} : {
  target: "e1ukuf8x0",
  label: "ImageWrapper"
})(({
  height,
  scale
}) => /*#__PURE__*/(0, _react.css)("display:flex;height:100%;& img{width:100%;max-height:", height, ";scale:", scale, ";}& video{width:100%;max-height:", height, ";scale:", scale, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:ImageWrapper;")));